<span *ngIf="deadline" [ngClass]="{'blink_me': time < 30 }" style="background-color: white;" >{{ deadline }}</span>